module.exports = __webpack_public_path__ + "img/image-11.625e0d23.jpg";